<template>
  <div class="thanks">
    <div class="message">
      <div class="thanks-inner">
        <h2 class="title">お問い合わせフォーム　送信完了</h2>
        <div class="sub-txt">
          ご登録いただき、ありがとうございました。
          <br />
          コンサルタントよりご連絡させていただきます。
        </div>
        <div class="txt">
          あなたのメールアドレスに「送信内容の確認メール」をお送りしました。
          <br />
          3日以上連絡がない場合は、m3.com CAREER 事務局（
          <a href="mailto:m3c-jimucho@m3career.com" style="color: #1877b2; text-decoration: underline;">m3c-jimucho@m3career.com</a>
          ）にご連絡ください。
        </div>
      </div>
    </div>

    <div class="form-area">
      <div class="thanks-inner form-inner">
        <div class="form-top">続いて、あなたに合った求人提案のため下記項目をご入力ください</div>
        <div class="form-top-sub">
          <span>面談希望日</span>もご指定いただけますのでぜひ、ご回答ください（所要時間1分程度）
        </div>

        <div class="thanks-form">
          <form @submit.prevent="handleSubmit" novalidate>
            <table>
              <tbody>
                <tr>
                  <th>現在の年収</th>
                  <td>
                    <select v-model="form.current_income">
                      <option value="">選択してください</option>
                      <option v-for="opt in salaryOptions" :key="'c-'+opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </td>
                </tr>

                <tr>
                  <th>ご希望の年収</th>
                  <td>
                    <select v-model="form.desired_income">
                      <option value="">選択してください</option>
                      <option v-for="opt in salaryOptions" :key="'d-'+opt.value" :value="opt.value">{{ opt.label }}</option>
                    </select>
                  </td>
                </tr>

                <tr>
                  <th>ご経験職種<br /><span>※複数選択可</span></th>
                  <td>
                    <div class="radio-wrap">
                      <div v-for="job in experienceJobOptions" :key="job" class="box">
                        <label>
                          <input type="checkbox" :value="job" v-model="form.experience_jobs" />
                          {{ job }}
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>面談希望日</th>
                  <td>
                    営業時間：平日9:30〜18:30
                    <br /><span>※営業時間外の場合にはご連絡が遅れる可能性がございます。</span>
                    <br /><span style="color: #f00; font-size: 12px;">※日付と時間の両方を選択してください</span>
                    <div class="days-wrap">
                      <div v-for="(interview, index) in form.interview_dates" :key="'iv-'+index">
                        <div class="box">
                          <input
                            type="date"
                            :value="interview.date"
                            :min="minDate"
                            @input="updateInterviewDate(index, 'date', $event.target.value)"
                            :style="dateErrorStyle(index)"
                          />
                          <select
                            :value="interview.time"
                            @change="updateInterviewDate(index, 'time', $event.target.value)"
                            :style="timeErrorStyle(index)"
                          >
                            <option value="">希望時間</option>
                            <option v-for="t in timeOptions" :key="t" :value="t">{{ t }}</option>
                          </select>
                        </div>
                        <div v-if="interviewDateErrors[index]" class="field-error">
                          {{ interviewDateErrors[index] }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>その他お問い合わせ</th>
                  <td>
                    <textarea
                      v-model="form.other_inquiry"
                      placeholder="200文字以内でお問い合わせ内容をご記入ください。"
                      maxlength="200"
                    />
                    <div style="margin-top: 4px; font-size: 12px; color: #666;">
                      {{ form.other_inquiry ? form.other_inquiry.length : 0 }}/200文字
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="submitError" style="margin-top: 16px; padding: 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px; color: #b91c1c; font-size: 14px;">
              <ul v-if="Array.isArray(submitError)" style="list-style: none; padding-left: 0;">
                <li v-for="(err, i) in submitError" :key="i">{{ err }}</li>
              </ul>
              <template v-else>{{ submitError }}</template>
            </div>

            <button type="submit" class="thanks-form-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '送信中...' : '希望条件を送信する' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SALARY_OPTIONS, TIME_OPTIONS, EXPERIENCE_JOB_OPTIONS } from '../../lib/lp_gym01/constants'
import { submitAddingQuestion } from '../../lib/lp_gym01/api_client'

export default {
  name: 'LpAddingQuestions',
  props: {
    inquiryId: { type: [String, Number], required: true },
    imagePaths: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      salaryOptions: SALARY_OPTIONS,
      timeOptions: TIME_OPTIONS,
      experienceJobOptions: EXPERIENCE_JOB_OPTIONS,
      form: {
        current_income: '',
        desired_income: '',
        experience_jobs: [],
        interview_dates: [
          { date: '', time: '' },
          { date: '', time: '' },
          { date: '', time: '' }
        ],
        other_inquiry: ''
      },
      interviewDateErrors: {},
      isSubmitting: false,
      submitError: null
    }
  },
  computed: {
    minDate () {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().split('T')[0]
    }
  },
  methods: {
    updateInterviewDate (index, field, value) {
      this.form.interview_dates[index][field] = value
      delete this.interviewDateErrors[index]
      this.submitError = null
    },
    dateErrorStyle (index) {
      const err = this.interviewDateErrors[index]
      return err && err.includes('日付') ? { borderColor: '#ef4444', borderWidth: '2px' } : {}
    },
    timeErrorStyle (index) {
      const err = this.interviewDateErrors[index]
      return err && err.includes('時間') ? { borderColor: '#ef4444', borderWidth: '2px' } : {}
    },
    validateInterviewDates () {
      var errors = {}
      var valid = true
      this.form.interview_dates.forEach(function (iv, i) {
        var hasDate = iv.date && iv.date.trim() !== ''
        var hasTime = iv.time && iv.time.trim() !== ''
        if (hasDate && !hasTime) {
          errors[i] = '第' + (i + 1) + '希望日の希望時間を選択してください'
          valid = false
        } else if (!hasDate && hasTime) {
          errors[i] = '第' + (i + 1) + '希望日の日付を選択してください'
          valid = false
        }
      })
      this.interviewDateErrors = errors
      return valid
    },
    handleSubmit () {
      var self = this
      self.submitError = null
      if (!self.validateInterviewDates()) return

      self.isSubmitting = true
      var payload = {
        current_income: self.form.current_income || undefined,
        desired_income: self.form.desired_income || undefined,
        experience_jobs: self.form.experience_jobs.length > 0 ? self.form.experience_jobs : undefined,
        lp_interview_dates: self.form.interview_dates
          .filter(function (iv) { return iv.date && iv.time })
          .map(function (iv) { return { date: iv.date, desired_time: iv.time } }),
        other_inquiry: self.form.other_inquiry || undefined
      }

      submitAddingQuestion(self.inquiryId, payload)
        .then(function (result) {
          if (result.success) {
            window.location.href = '/lp/gym_01/thanks'
            return
          }
          self.submitError = (result.errors && result.errors.length > 0) ? result.errors : ['エラーが発生しました']
        })
        .catch(function () {
          self.submitError = '送信中にエラーが発生しました'
        })
        .then(function () {
          self.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.field-error {
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #ef4444;
  padding-left: 8px;
}
</style>
